"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var http_client_1 = __importDefault(require("@fuze/apis-core/dist/http-client"));
var getFoundryDefaultHeaders_1 = __importDefault(require("../../getFoundryDefaultHeaders"));
var originHeader_1 = require("@fuze/apis-core/dist/originHeader");
function validateServices(baseUrl, wardenToken, origin, services) {
    if (services === void 0) { services = []; }
    return http_client_1.default({
        method: "POST",
        url: baseUrl + "/v1/services/provision/validation?uowValidation=false",
        headers: __assign(__assign({}, getFoundryDefaultHeaders_1.default(wardenToken)), originHeader_1.createOriginHeader(origin)),
        data: {
            services: services
        }
    }).then(function (response) { return response.data; });
}
exports.default = validateServices;
